<template>
  <div class="search-input-container" :class="{ 'close-state': inputState, focus: hasFocus }">
    <input
      v-if="inputState"
      v-model="innerValue"
      @input="startTimerForSearch"
      @focus="handleFocus"
      @blur="handleBlur"
      :class="theme === 'light' ? 'light' : ''"
      :style="`background: ${backgroundColor}; color: ${color}; height: ${inputHeight}`"
      ref="input"
      type="text"
      placeholder="Pesquisar"
    />

    <div class="icon-container">
      <i
        :class="!inputState ? 'icon-search' : 'icon-close'"
        @click="toggleInput"
        :style="`color: ${color}`"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputSleep: {
      type: Number,
      default: 500,
    },

    theme: {
      type: String,
      default: "",
    },

    color: {
      type: String,
      default: "#ffffff",
    },

    backgroundColor: {
      type: String,
      default: "#282d35",
    },

    inputHeight: {
      type: String,
      default: "46px",
    },

    value: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      inputState: false,
      innerValue: this.value,
      timer: 0,
      hasFocus: false,
    };
  },

  methods: {
    startTimerForSearch() {
      this.$emit("input", this.innerValue);

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.$emit("fetch", this.innerValue);
      }, this.inputSleep);
    },

    toggleInput() {
      this.inputState = !this.inputState;

      this.$emit("toggle", this.inputState);

      if (!this.inputState) {
        this.innerValue = "";

        this.startTimerForSearch();
      } else {
        this.$nextTick(() => this.$refs.input.focus());
      }
    },

    handleFocus() {
      this.hasFocus = true;
    },

    handleBlur() {
      this.hasFocus = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input-container {
  display: flex;
  width: 100%;

  &.focus {
    .icon-container {
      i {
        color: #046af3;
      }
    }
  }

  &.close-state {
    align-items: center;
    justify-content: flex-end;
    position: relative;

    input {
      display: block;
      margin-right: 0;
      padding: 0 3rem 0 1rem;
      border-radius: 5px;
    }

    .icon-container {
      position: absolute;

      i {
        font-size: 18px;
      }
    }
  }

  input {
    margin-right: 1rem;
    border: 1px solid #181b20;
    height: 46px;
    width: 100%;
    display: none;
    &.light {
      background: #fff;
      color: #282d35;
    }
    &:focus {
      outline: none;
      border: 2px solid #046af3;
      caret-color: #046af3;
    }
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;

    i {
      font-size: 2rem;
      color: #fff;
      margin-right: 1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      transition: 0.2s opacity ease-in-out;
    }
    .icon-search:hover {
      opacity: 0.7;
    }
  }
}
</style>
